module.exports = __webpack_public_path__ + "img/stripe-s.75c7790f.svg";